import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MdConfirmationNumber } from 'react-icons/md';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Field from 'legacy/common/components/wysiwyg-form/Field';
import { useCreateComplimentaryTickets } from '../../../../../hooks';

import styles from '../FormStyles.module.scss';

const ComplimentaryTicketsSchema = Yup.object().shape({
  name: Yup.string().max(100).required('Required').label('Name'),
  quantity: Yup.number()
    .min(0)
    .max(999999)
    .required('Required')
    .label('Available tickets')
});

const ComplimentaryTicketForm = ({ closeModal, eventId, refetchTickets }) => {
  const { mutate: createTickets } = useCreateComplimentaryTickets();

  const onSubmit = ({ name, quantity }) => {
    createTickets(
      { eventId, name, quantity },
      {
        onSuccess: () => {
          refetchTickets();
          closeModal();
        },
        onError: () => {
          closeModal();
        }
      }
    );
  };

  return (
    <Formik
      initialValues={{ name: '', quantity: '' }}
      onSubmit={onSubmit}
      validationSchema={ComplimentaryTicketsSchema}
    >
      {({ isValid, submitForm }) => (
        <Modal
          visible
          onClose={closeModal}
          type={ModalType.SMALL}
          title="Add Complimentary Ticket"
          icon={<MdConfirmationNumber size={20} />}
          autoHeight
          renderFooter={() => (
            <div className="flex gap-3">
              <Button type={ButtonType.Primary} onClick={submitForm}>
                Create Tickets
              </Button>
            </div>
          )}
        >
          <div className="p-4">
            <Form>
              <div>
                <Field
                  id="name"
                  name="name"
                  type="text"
                  label="Name*"
                  placeholder="e.g. Party people VIP package"
                />
                <Field
                  id="quantity"
                  name="quantity"
                  type="number"
                  label="Available tickets*"
                  placeholder="e.g. 10"
                />
              </div>
            </Form>

            <div className={styles.footer}>
              <Button
                isSubmit
                type={ButtonType.Primary}
                disabled={!isValid}
                testId="button-confirm-ticket"
                onClick={submitForm}
              >
                Create Tickets
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </Formik>
  );
};

export default ComplimentaryTicketForm;
